import { z } from "zod";

export const zodSchema = {
  phone: z
    .string()
    .length(14, { message: "Phone number is not valid" })
    .refine(
      (value: string) => {
        return /^\+[0-9]+$/.test(value);
      },
      { message: "Phone number must only contain numbers" },
    ),
  password: z
    .string()
    .min(6, { message: "Password must be at least 6 characters" })
    .max(100, { message: "Password must not be more than 100 characters" }),
  // .regex(/[A-Z]/, {
  //   message: "Password must contain at least one capital letter",
  // })
  // .regex(/[0-9]/, { message: "Password must contain at least one number" })
  // .regex(/[//!@#$%^&*(),.?":{}|<>]/, {
  //   message: "Password must contain at least one special character",
  // }),
};
